// Query credentials can occur in request URLs, referrers, error messages and
// nested/encoded redirect URLs. Keep route, attribution and ordinary IDs intact.
const SECRET_PARAMS = new Set([
  "code",
  "state",
  "handoff_code",
  "handoffcode",
  "desktop_nonce",
  "desktopnonce",
  "code_verifier",
  "code_challenge",
  "jwt",
  "token",
  "token_hash",
  "access_token",
  "refresh_token",
  "id_token",
  "session_token",
  "interview_session_token",
  "api_key",
  "api-key",
  "apikey",
  "key",
  "key_value",
  "sig",
  "signature",
  "secret",
  "client_secret",
  "auth",
  "authorization",
  "password",
  "pwd",
  "x-amz-signature",
  "x-amz-credential",
  "x-amz-security-token",
])

/** Sanitize without decoding/reformatting the URL itself, including duplicates. */
export function redactUrlCredentials(value: string): string {
  // Recognize query delimiters up to three encodings deep (redirect-within-URL).
  const prefix = /([?&#]|%(?:25){0,2}(?:3f|26|23))([a-z0-9%_.~-]{1,128}?)(=|%(?:25){0,2}3d)/gi
  let out = ""
  let copied = 0
  for (let match = prefix.exec(value); match; match = prefix.exec(value)) {
    let name = match[2]
    for (let depth = 0; depth < 3 && name.includes("%"); depth++) {
      try {
        name = decodeURIComponent(name)
      } catch {
        break
      }
    }
    if (!SECRET_PARAMS.has(name.toLowerCase())) continue
    const start = prefix.lastIndex
    const encoded = match[1].startsWith("%")
    const depth = encoded ? (match[1].length - 3) / 2 : 0
    // An encoded ampersand inside an ordinary value is part of that secret,
    // not a separator. Only stop at delimiters at this URL's encoding level.
    const endPattern = encoded
      ? new RegExp(`[&#\\s\"'<>]|%(?:25){${depth}}(?:26|23)`, "i")
      : /[&#\s"'<>]/
    const relativeEnd = value.slice(start).search(endPattern)
    const end = relativeEnd < 0 ? value.length : start + relativeEnd
    out += value.slice(copied, start) + "[redacted]"
    copied = end
    prefix.lastIndex = end
  }
  return copied ? out + value.slice(copied) : value
}
